export const logoFormContentStyle = {
	wrapper: {
		width: '100%',
		margin: '0 auto',
	},

	avatar: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: '40px',
	},
};
